import React, { useState, Fragment } from 'react'
import { FormField, Label, TextInput } from '../../ui/form';

import { CheckoutSettings } from '../request/apis'
import { tips } from '../locales'
import storage from '../utils/storage'

const PaymentsAdditionalTextField = (props: { checkoutSettings: CheckoutSettings }) => {

  const {
    checkoutSettings: {
      checkoutPaymentAdditionalExtraFields,
      checkoutPaymentAdditionalExtraFieldsRequired,
    },
  } = props

  const [paymentsAdditionalTextFieldValue, setPaymentsAdditionalTextFieldValue] = useState(storage.B3PaymentsAdditionalTextFieldValue.getValue() || '')

  const handleAdditionalTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setPaymentsAdditionalTextFieldValue(value)
    value ? storage.B3PaymentsAdditionalTextFieldValue.setValue(value) : storage.B3PaymentsAdditionalTextFieldValue.removeValue()
  }

  const renderField = () => (
    <Fragment>
      <Label
        className="form-legend optimizedCheckout-contentSecondary"
        htmlFor="additional-text-field"
        style={ { cursor: 'pointer' } }
      >
        { checkoutPaymentAdditionalExtraFields?.value }
        {
          +checkoutPaymentAdditionalExtraFieldsRequired.value === 0 &&
          <small className="optimizedCheckout-contentSecondary">
            <span>{ tips['b3.label.optional'] }</span>
          </small>
        }
      </Label>

      <TextInput
        id="additional-text-field"
        onChange={ handleAdditionalTextFieldChange }
        type="text"
        value={ paymentsAdditionalTextFieldValue }
      />
    </Fragment>
  )

  return (
    <div className="b3-additional-text-field">
      <FormField input={ renderField } name="PaymentsAdditionalTextField" />
    </div>
  )
}

export default PaymentsAdditionalTextField
